<template>
  <div class="mobile headmaster_historical">
    <div class="headmaster_screen">
      <div class="screen_order" @click="orderChange">
        <span>最新</span>
        <div class="order_icon">
          <div class="up" :class="[latest?'orderUpColor':'']"></div>
          <div class="down" :class="[latest?'':'orderDownColor']"></div>
        </div>
      </div>
      <div class="screen_icon" @click="showPicker=true">
        <DsfIcon name="filter"></DsfIcon>
        <span>{{selectTypeText}}</span>
      </div>
    </div>
    <div class="list_box">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="historical_item" v-for="(item,index) in list" :key="index">
            <DsfHistoricalSubmissionCard :cardValue="item" :isStudent="false"></DsfHistoricalSubmissionCard>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker title="类型选择" show-toolbar :columns="radioArr" @cancel="showPicker=false" value-key="dsfa_rm_dict_list.value" @confirm="onConfirm" />
    </van-popup>

  </div>
</template>index

<script>
import DsfHistoricalSubmissionCard from "./historicalSubmissionCard";
export default dsf.component({
  name: "DsfMobileHeadmasterHistorical",
  ctrlCaption: "班主任历史提交",
  mixins: [$mixins.control],
  components: {
    DsfHistoricalSubmissionCard
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      latest: true,
      pageSize: 1,
      pageNum: 10,
      radioArr: [],
      selectType: '',
      selectTypeText: "全部板块",
      showPicker: false,
      listCount: 0
    };
  },
  created() {
    if (this.isDesign) {
      this.listCount = 1;
      this.list = [{
        attachment: JSON.stringify([{ relativePath: '/upload/files/20220304/5490bd5eefd34af3987ae42c8b5b59dc.jpg' }]),
        dsCreateTime: "2022-03-04 14:38",
        replyStatusValue: '0',
        replyStatusText: "未回复",
        suggest: "63456345345",
        typeText: "后勤保障",
        stuName: "学员01",
        className: "测试请假与评估关联班",
        suggestReplyList: [],
        photo: "[{\"originalFileName\":\"f18d063759cdf9b7dff6477fffce279b.jpg\",\"suffix\":\"jpg\",\"size\":19422,\"uploadDate\":\"2022-03-02 10:09:40\",\"relativePath\":\"/upload/files/20220302/054b2d2adba141df9f38863e05ec98e4.jpg\",\"name\":\"f18d063759cdf9b7dff6477fffce279b\",\"absolutePath\":\"http://192.168.0.61/upload/files/20220302/054b2d2adba141df9f38863e05ec98e4.jpg\",\"id\":\"123aa8721985468282c7885d020fe33a\",\"contentType\":\"image/jpeg\"}]"
      }]
    } else {
      this.getType();
      this.getList();
    }

  },
  activated() {
    this.list = [];
    this.pageSize = 1;
    this.getList();
  },
  methods: {
    // 获取类型
    getType() {
      let data = {
        id: 'db1c08d2248147dda9f550850147b429',
        pageName: 'treedictedit',
        namespace: 'dsfa.rm.dict',
        data: JSON.stringify({
          "_id": "db1c08d2248147dda9f550850147b429"
        })
      }
      this.$http.get('/meta/data', data)
        .done((res) => {
          if (res.success && res.state == 20000) {
            this.radioArr = [{ 'dsfa_rm_dict_list.value': "全部板块" }, ...res.data.dsfa_rm_dict_list] || [];
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
    },
    // 获取数据
    getList() {
      let data = {
        type: this.selectType,
        latest: this.latest,
        reply: this.queryString.reply || '',
        searchValue: '',
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      let that = this;
      this.$http.get('/mobile/classes/suggest/getStuSuggestList', data).done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          this.list.push(...res.data.suggestDetailVoList);
          this.listCount = res.data.count;
          this.pageSize++;
        } else {
          dsf.layer.message(res.message, false);
        }
      })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
    },
    // 拍讯
    orderChange() {
      this.list = [];
      this.pageSize = 1;
      this.latest = !this.latest;
      this.getList();
    },
    // 确认
    onConfirm(value, index) {
      if (index) {
        this.selectType = value['dsfa_rm_dict_list.code'];
        this.selectTypeText = value['dsfa_rm_dict_list.value'];
      } else {
        this.selectType = "";
        this.selectTypeText = "全部板块"
      }
      this.pageSize = 1;
      this.list = [];
      this.getList()
      this.showPicker = false;
    },
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.pageSize = 1;
          this.list = [];
          this.refreshing = false;
        }
        if ( this.list.length == this.listCount) {
          this.finished = true;
        } else {
          this.getList()
        }
        this.loading = false;
      }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
})
</script>

<style>
</style>